export enum Role {
  ACTIVE = 'Active',
  ADMIN = 'Admin',
  COORDINATOR = 'Koordinátor',
  CUSTOMER_SERVICE = 'Ügyfélszolgálat',
  PERFORMANCE_PAY = 'Teljesítménybér',
}
